import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取派送费用查询
export const getDeliveryList = params => {
  return axios.request({
    url: "/finance/DutyClaim/delivery",
    method: "get",
    params
  });
};
